import { duplicate } from 'actions/restActions'
import { LOCALES_SUPPORTED_CUSTOMER_FACING } from 'constants/locales'
import { authSelectors } from 'ducks/auth'
import EditOrImportButton from 'elements/button/EditOrImportButton'
import Empty from 'elements/Empty'
import { NotFoundVersioned } from 'elements/NotFoundVersioned'
import ListActions from 'elements/react-admin/ListActions'
import { ComponentVersionsInherit, ComponentVersions_3_0 } from 'opensolar-ui'
import { useMemo } from 'react'
import { BooleanField, Create, Datagrid, Edit, FunctionField, List, useTranslate } from 'react-admin'
import { useDispatch, useSelector } from 'react-redux'
import { useFeatureFlag } from 'util/featureFlags'
import ExpoStandForm from './ExpoStandForm'

export const ExpoStandList = (props) => {
  const dispatch = useDispatch()
  const translate = useTranslate()
  const isAdmin = useSelector(authSelectors.getIsAdmin)
  const isStaff = useSelector(authSelectors.getIsStaff)
  const expoEnabled = useFeatureFlag('expo', 'on')
  const duplicateFunc = (payload) => {
    dispatch(duplicate(payload))
  }
  const listLabels = useMemo(
    () => ({
      createBtn: `Create Expo ${props.homepage ? 'Homepage Highlight' : 'Stand'}`,
      emptyLabel: translate(`Expo ${props.homepage ? 'Homepages' : 'Stands'}`),
    }),
    [props.homepage]
  )
  if (!expoEnabled && !isStaff) return <NotFoundVersioned />

  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <List
        {...props}
        perPage={20}
        hasCreate={isAdmin}
        actions={<ListActions createButtonLabel={listLabels.createBtn} {...props} />}
        empty={<Empty resourceName={listLabels.emptyLabel} />}
        data-testid={`expo-${props.homepage ? 'homepages' : 'stands'}-list`}
      >
        <Datagrid>
          <FunctionField source={'title'} label="Title" render={(record) => record.title} />
          <FunctionField
            source={'countries_include'}
            label={'Countries Included'}
            render={(record) => record.countries_include}
          />
          <FunctionField
            label={'Language'}
            displayInCard={true}
            render={(record) => {
              const selected = LOCALES_SUPPORTED_CUSTOMER_FACING[record.locale]
              return selected
            }}
          />
          {!props.homepage && (
            <FunctionField source={'brand'} label="Brand" render={(record) => record.brand_content?.name} />
          )}
          <BooleanField source="is_published" label={'Is Published'} displayInCard={true} sortable={false} />
          <EditOrImportButton
            sortable={false}
            source="actions"
            label="Actions"
            org_id={props.org_id}
            resource={props.resource}
            duplicate={duplicateFunc}
            isAdmin={isAdmin}
            allowEdit={isAdmin}
            allowDelete={isAdmin}
          />
        </Datagrid>
      </List>
    </ComponentVersionsInherit>
  )
}

export const ExpoStandCreate = (props) => {
  const expoEnabled = useFeatureFlag('expo', 'on')
  if (!expoEnabled) return <NotFoundVersioned />
  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <Create {...props}>
        <ExpoStandForm {...props} />
      </Create>
    </ComponentVersionsInherit>
  )
}

export const ExpoStandEdit = (props) => {
  const expoEnabled = useFeatureFlag('expo', 'on')
  if (!expoEnabled) return <NotFoundVersioned />
  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <Edit {...props}>
        <ExpoStandForm {...props} />
      </Edit>
    </ComponentVersionsInherit>
  )
}
